import { Component, OnInit } from '@angular/core';
import { MenuService } from '../menu.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-menus',
    templateUrl: './menus.component.html',
    styleUrls: ['./menus.component.scss']
})
export class MenusComponent implements OnInit {

    menus = [];
    menuGroups = [];
    menuGroup;
    toSave = [];
    primaryMenu;
    subMenu;
    showConfirmation = false;
    categoryToDelete;
    parentId = 0;
    level = 1;
    showCreateModal = false;
    currentMenu;

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    constructor(
        private toastrService: ToastrService,
        private menuService: MenuService,
    ) { }

    ngOnInit() {
        this.getMenuGroups();
    }

    get() {
        this.menuService.all().subscribe(data => {
            this.menus = data;
        });
    }

    getMenuGroups() {
        this.menuService.menuGroups().subscribe(data => {
            this.menuGroups = data;
            this.setMenuGroup(0);
            this.getMenuGroupMenus();
        })
    }

    getMenuGroupMenus() {
        this.menuService.menuGroupMenus(this.menuGroup).subscribe(data => {
            this.menus = data;
        });
    }

    setMenuGroup(idx) {
        this.menuGroup = this.menuGroups[idx];
        this.getMenuGroupMenus();
    }

    setsubMenu(cat) {
        this.primaryMenu = cat;
        this.subMenu = cat.secondaryCategories;
    }

    drop(e) {
        // moveItemInArray(this.images, event.previousIndex, event.currentIndex);
        this.toSave = e;
        this.menuService.saveSortation(this.toSave).subscribe(data => {
        });

    }

    dropSub(e) {
        // moveItemInArray(this.images, event.previousIndex, event.currentIndex);
        this.toSave = e;
        this.menuService.saveSortation(this.toSave).subscribe(data => {
        });

    }


    toggleOpen(cat) {
        if (!cat.open) {
            cat.open = true;
        } else {
            cat.open = false;
        }
    }


    deleteConfirm(category) {
        this.confirmationData.title = 'Please confirm you would like to delete this menu item';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;

        this.categoryToDelete = category;
    }
    confirmAction(e) {
        if (e.action) {
            this.menuService.delete(this.categoryToDelete).subscribe(data => {
                this.toastrService.success('Menu deleted');
                // this.subMenu = undefined;
                this.getMenuGroupMenus();
            });
        }
        this.confirmationData.open = false;
    }

    createMenu(currentMenu, parentId, level) {
        this.parentId = parentId;
        this.level = level;

        this.currentMenu = currentMenu;

        this.showCreateModal = true;
    }

    createModalAction(e) {
        if (e.completed) {
            this.toastrService.success('Menu added');
            this.subMenu = undefined;
            this.getMenuGroupMenus();
        }
        this.showCreateModal = false;
    }
}
